
/// <amd-module name="Build/DesignerExtensions/ExclusiveLockCheckPanel/Constants" />

export const ExclusiveLockPolicyTypeIdString: string = "2EF31AD6-BAA0-403A-8B45-2CBC9B4E5563";
export const ExclusiveLockPolicyTypeName: string = "ExclusiveLock";
export const ExclusiveLockDataProvider: string = "ms.vss-build-web.resource-lock-data-provider";